import { render } from "./LearnMore.vue?vue&type=template&id=85a9d2ce"
import script from "./LearnMore.vue?vue&type=script&lang=js"
export * from "./LearnMore.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__